import Textarea from '@/components/ui/textarea/textarea';

export default Textarea;
